import request from "@/lib/request/request";
import Model from "../model";
import Auth from "@/lib/common/auth";

export class ITemplateReq extends Model {
  env = 1;
  type = 0;
  nameLike = "";
  auditStatusList = [];
  page = 1;
  pageSize = 10;
}

export class TemplateCreate extends Model {
  env = 1;
  type = 1;
  name = "";
  isDefault = 1;
  isClose = 1;
  mobileContent = "";
  emailContentHtml = "";
  emailName = "";
  emailSubject = "";
}

export class TemplateUpdate extends Model {
  templateId = "";
  name = "";
  isDefault = 1;
  isClose = 1;
  mobileContent = "";
  emailContentHtml = "";
  emailName = "";
  emailSubject = "";
}

export class TemplateNew extends Model {
  templateId = 0; // 模版id
  companyId = Auth.companyId; // 公司id
  env = 1; // 模板场景
  type = 0; // 模板类型
  isSystem = 0; // 是否是系统级别默认模板
  auditStatus = 0; // 审核结果 0:未审核 1:通过 2:拒绝
  auditReason = ""; // 审核驳回原因
  createdTime = ""; // 创建时间
  name = ""; // 模板名称
  isDefault = 0; // 是否是公司级别默认模板
  isClose = 0; // 是否关闭发送
  mobileContent = ""; // 短信内容
  emailContentHtml = ""; // 邮件内容
  emailName = ""; // 邮件发件人
  emailSubject = ""; // 邮件主题
  emailContentTextOnly = ""; // 邮件内容纯文本-冗余

  static getList(params: ITemplateReq) {
    return request
      .postInterviewApi("/hr/messageTemplate/list", params)
      .then(resp => resp.data);
  }

  static create(params: TemplateCreate) {
    return request
      .postInterviewApi("/hr/messageTemplate/create", params)
      .then(resp => resp.data);
  }

  static update(params: TemplateUpdate) {
    return request
      .postInterviewApi("/hr/messageTemplate/update", params)
      .then(resp => resp.data);
  }

  static delete(templateId: number) {
    return request
      .postInterviewApi("/hr/messageTemplate/delete", { templateId })
      .then(resp => resp.data);
  }

  static getDetail(templateId: number) {
    return request
      .postInterviewApi("/hr/messageTemplate/get", { templateId })
      .then(resp => resp.data);
  }
}
